import { render, staticRenderFns } from "./DomainBox.vue?vue&type=template&id=3c2df2b4&scoped=true&"
import script from "./DomainBox.vue?vue&type=script&lang=js&"
export * from "./DomainBox.vue?vue&type=script&lang=js&"
import style0 from "./DomainBox.vue?vue&type=style&index=0&id=3c2df2b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2df2b4",
  null
  
)

export default component.exports